import { Divider, Grid } from "@mui/material";
import TextOverflow from "../../../_src_shared/components/TextOverflow";
import Txt from "../../typography/Txt";
import RffAddressInputField from "../inputs/RffAddressInputField";
import RffBooleanToggleField from "../inputs/RffBooleanToggleField";
import RffDateField from "../inputs/RffDateField";
import RffEmailField from "../inputs/RffEmailField";
import RffFileUploadField from "../inputs/RffFileUploadField";
import RffPhoneField from "../inputs/RffPhoneField";
import RffSelectAutocompleteField from "../inputs/RffSelectAutocompleteField";
import RffSelectToggleField from "../inputs/RffSelectToggleField";
import RffSignatureField from "../inputs/RffSignatureField";
import RffSsnField from "../inputs/RffSsnField";
import RffTextField from "../inputs/RffTextField";
import RffConditional from "../shared/RffConditional";
import RffGroup from "../shared/RffGroup";
import { selectOptionsMaritalStatus } from "../../../constants/selectOptions/selectOptionsMaritalStatus";

const CreditAuthorizationFormQuestions = ({
  dividers,
  suppressBottomMargin,
}) => {
  return (
    <>
      <BorrowerDetailsPage
        stepName="Borrower Details"
        suppressBottomMargin={suppressBottomMargin}
      />
      {dividers && <Divider />}
      <UploadFilesPage
        stepName="Upload Files"
        suppressBottomMargin={suppressBottomMargin}
      />
      {dividers && <Divider />}
      <RffSectionAuthorizationSignature
        stepName="Confirmation"
        suppressBottomMargin={suppressBottomMargin}
      />
    </>
  );
};

export const BorrowerDetailsPage = ({ suppressBottomMargin }) => {
  return (
    <RffGroup suppressBottomMargin title={"Borrower Details"}>
      <RffTextField name="firstName" label="First Name" size={6} required />
      <RffTextField name="lastName" label="Last Name" size={6} required />
      <RffPhoneField name="phone" label="Phone" required size={6} />
      <RffEmailField name="emailAddress" label="Email" required size={6} />
      <RffDateField
        name="dateOfBirth"
        label="Enter date of birth"
        required
        size={6}
      />

      <RffSelectAutocompleteField
        name="citizenshipStatus"
        label="Please select your citizenship category"
        options={[
          "US Citizen",
          "Foreign National with SSN",
          "Foreign National",
          "Foreign National Non-Resident",
          "Other - Options do not apply",
        ]}
        size={6}
        required
      />
      <RffConditional
        operatorForMultiple={"OR"}
        rules={[
          { field: "citizenshipStatus", operator: "==", value: "US Citizen" },
          {
            field: "citizenshipStatus",
            operator: "==",
            value: "Foreign National with SSN",
          },
          {
            field: "citizenshipStatus",
            operator: "==",
            value: "Foreign National",
          },
        ]}
      >
        <RffAddressInputField
          name="primaryAddress"
          label="Primary Address"
          required
        />
      </RffConditional>
      <RffConditional
        operatorForMultiple={"OR"}
        rules={[
          {
            field: "citizenshipStatus",
            operator: "==",
            value: "Foreign National Non-Resident",
          },
          {
            field: "citizenshipStatus",
            operator: "==",
            value: "Other - Options do not apply",
          },
        ]}
      >
        <RffTextField
          required
          name="nonUSborrowerAddress"
          label="Enter non-US address"
        />
      </RffConditional>

      <RffSelectToggleField
        name="maritalStatus"
        label="What is your marital Status?"
        options={selectOptionsMaritalStatus}
        required
        size={6}
      />
      <RffBooleanToggleField
        name="borrowerHasSSN"
        label="Do you have a US issued Social Security Number?"
        required
        size={6}
      />
      <RffConditional field={"borrowerHasSSN"} value={true}>
        <RffSsnField
          name="borrowerSSN"
          label="Social Security Number"
          // size={4}
        />
      </RffConditional>
    </RffGroup>
  );
};

export const UploadFilesPage = ({ suppressBottomMargin }) => {
  return (
    <>
      <RffGroup suppressBottomMargin title="Idenfication Upload">
        <RffFileUploadField
          required
          label="Upload Photo Identification"
          docGroup={"Borrower Documents"}
          docType={"Photo Identification"}
          helperText="Please ensure to upload both front and back of identification"
        />
      </RffGroup>
    </>
  );
};

export const RffSectionAuthorizationSignature = ({ hideTitle }) => {
  return (
    <>
      <RffGroup
        suppressBottomMargin
        title={hideTitle ? null : "Disclosure & Signature"}
      >
        <Grid item xs={12}>
          <TextOverflow title={"Authorization Agreement"}>
            <Txt>
              Applicant attests that this application is for financing of a
              business purpose loan and any subject properties covered under
              this application are not owner occupied, used as a second home or
              vacation property, and any recent use of the property as a primary
              residence will require supporting evidence that all guarantors and
              their family members are no longer occupying the residence.
            </Txt>
            <Txt>
              The actual terms and conditions upon which the Lender might extend
              credit are subject to satisfactory completion of due diligence,
              internal approval, satisfactory review of documentation and such
              other or different items and conditions as may be determined by
              the Lender following the completion of its underwriting (the
              “Underwriting and Approval Process”). As a result, notwithstanding
              any agreement of the parties to the contrary, (i) Lender’s
              approval of the loan documents shall not constitute a final
              approval of the loan and (ii) the loan documents shall not be
              considered final until the Underwriting and Approval Process is
              completed (as determined in Lender’s sole discretion).
            </Txt>
            <Txt>
              The borrower hereby agrees that all aforementioned information is
              true and in no means is false and intended to influence the credit
              underwriting of the Lender in regard to origination of the loan
              associated with the subject property or properties. Additionally,
              the borrower understands that this loan application does not
              constitute a commitment from the Lender to originate the loan
              associated with the subject property or properties. Lastly, the
              borrower acknowledges that all fees collected in relation to loan
              due diligence are non-refundable, in any circumstance.
            </Txt>
          </TextOverflow>
        </Grid>
        <RffSignatureField name="signature" label="Signature" required />
      </RffGroup>
    </>
  );
};

export default CreditAuthorizationFormQuestions;
// {
//     "_id": "68658f61bcdf1453a4e3f117",
//     "dateOfBirth": "1992-11-10T05:00:00.000Z",
//     "emailAddress": "joliva@cliffcomortgage.com",
//     "firstName": "Jimmyyya",
//     "lastName": "Oliva",
//     "maritalStatus": "Married",
//     "phone": "6314563373",
//     "borrowerHasSSN": true,
//     "citizenshipStatus": "Foreign National with SSN",
//     "primaryAddress": {
//         "id": "A-1yb5xFhzjCuSufdQxVXQ-1751396905044",
//         "fullAddress": "125 Carley Avenue, Huntington, NY 11743",
//         "streetNumber": "125",
//         "streetName": "Carley Avenue",
//         "zip": "11743",
//         "county": "NY",
//         "state": "New York",
//         "city": "Huntington",
//         "country": "United States",
//         "countryCode": "US",
//         "latitude": 40.866112,
//         "longitude": -73.43475,
//         "coordinateTuple": [
//             40.866112,
//             -73.43475
//         ],
//         "score": 1
//     },
//     "borrowerSSN": "123456789",
//     "uploadMetadata": [
//         {
//             "id": "0f88c87f-6044-4a03-9031-867cf1222c49",
//             "name": "driver-lisc-back.jpg",
//             "file_display_name": "driver-lisc-back.jpg",
//             "docGroup": "Borrower Documents",
//             "docType": "Photo Identification"
//         },
//         {
//             "id": "34e03285-55d5-49a3-a54b-152eb80548a8",
//             "name": "driver-lisc-front.jpg",
//             "file_display_name": "driver-lisc-front.jpg",
//             "docGroup": "Borrower Documents",
//             "docType": "Photo Identification"
//         }
//     ],
//     "signature": "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAABE4AAAE7CAYAAADD68RZAAAAAXNSR0IArs4c6QAAIABJREFUeF7t3b2vJcl9HuBSxkCBAwc0QIAaQKEDOVNizE5mZwoIWIpmJ3RkOzIcCDubCXAgJwacDTeSDTtwYljZ7EZWoMB/gIDRAgTM0CGz1X2Xp7jF5vk+3aequ58GLu6dued0Vz2/WoLnnfr4veIiQIAAAQIECBAgQIAAAQIECBA4KvB7XAgQIECAAAECBAgQIECAAAECBI4LCE6MDAIECBAgQIAAAQIECBAgQIDACQHBiaFBgAABAgQIECBAgAABAgQIEBCcGAMECBAgQIAAAQIECBAgQIAAgdsEzDi5zcurCRAgQIAAAQIECBAgQIAAgR0JCE52VGxdJUCAAAECBAgQIECAAAECBG4TEJzc5uXVBAgQIECAAAECBAgQIECAwI4EBCc7KrauEiBAgAABAgQIECBAgAABArcJCE5u8/JqAgQIECBAgAABAgQIECBAYEcCgpMdFVtXCRAgQIAAAQIECBAgQIAAgdsEBCe3eXk1gbkE/qCUkq9c9fvfl1Lq11zPcR8CBAgQIECAAAECBAgQeEBAcPIAnrcSuEIgochnpZSfHr7n52uuNkT55hCofH3NG72GAAECBAgQIECAAAECBOYTEJzMZ+lOBKpAwpK3L2HH581skjl0apiSAOXblyAm3/N3LgIECBAgQIAAAQIECBBYSEBwshCs2+5OIGHJF4ew5Jmdr8FJnY3y1SGs+fnhe36ftrXfn9k ",
//     "query_params": {},
//     "submission_date": "2025-07-02T19:58:25.004000",
//     "client_ip": "148.77.45.139",
//     "portal_user": {
//         "_id": "68624bd32be3cdb8592f6dc7",
//         "firstName": "Jimmyyya",
//         "lastName": "Oliva",
//         "phone": "6314563373",
//         "emailAddress": "joliva@cliffcomortgage.com",
//         "referralSource": "borrower_portal"
//     },
//     "createdBy": "joliva@cliffcomortgage.com",
//     "borrower_portal_users": [
//         "68624bd32be3cdb8592f6dc7"
//     ],
//     "documents": [
//         {
//             "_id": "68658f61bcdf1453a4e3f118",
//             "containerName": "68658f61bcdf1453a4e3f117",
//             "file_name_as_loaded": "driver-lisc-back.jpg",
//             "file_display_name": "driver-lisc-back.jpg",
//             "file_storage_name": "e9e77e74-577e-11f0-858b-eab4601fb3da.jpg",
//             "content_type": "image/jpeg",
//             "size": 1273451,
//             "uploadedBy": "joliva@cliffcomortgage.com",
//             "uploadDate": "2025-07-02T19:58:25.024000"
//         },
//         {
//             "_id": "68658f61bcdf1453a4e3f11a",
//             "containerName": "68658f61bcdf1453a4e3f117",
//             "file_name_as_loaded": "driver-lisc-front.jpg",
//             "file_display_name": "driver-lisc-front.jpg",
//             "file_storage_name": "ea037a48-577e-11f0-858b-eab4601fb3da.jpg",
//             "content_type": "image/jpeg",
//             "size": 1418217,
//             "uploadedBy": "joliva@cliffcomortgage.com",
//             "uploadDate": "2025-07-02T19:58:25.207000"
//         }
//     ]
// }
